// Контакты компании — единый источник для шапки, форм, попапа и футера.
export const contacts = {
  phone: "+7 (915) 390-78-83",
  phoneHref: "tel:+79153907883",
  email: "v.k-klimat@mail.ru",
  emailHref: "mailto:v.k-klimat@mail.ru",
  address: "г. Дмитров, ул. Космонавтов, д. 37А",
  hours: "Пн–Пт 9:00–20:00",
  tagline: "Вентиляция и кондиционирование под ключ",
  requisites: "ВК-КЛИМАТ",
};

// Данные Оператора для Политики обработки персональных данных (замените на реальные).
export const operator = {
  name: "ООО «ВК-КЛИМАТ»", // название/ФИО оператора
  email: "v.k-klimat@mail.ru",
  site: "https://vk-klimat.ru",
  policyUrl: "https://vk-klimat.ru/privacy-policy",
};

// Мессенджеры/соцсети. Пока скрыто (пустой массив) — добавьте записи, когда появятся ссылки:
// { label: "Telegram", href: "https://t.me/...", icon: "telegram" }
export const socials = [];

export const advantages = [
  "Более 19 лет опыта",
  "Работа по договору",
  "Гарантия 1 год",
  "От проекта до запуска",
];

export const stats = [
  { value: "19+", label: "лет опыта" },
  { value: "500+", label: "объектов сдано" },
  { value: "1 год", label: "гарантии" },
  { value: "7", label: "направлений" },
];

export const objectTypes = ["Дома", "Коттеджи", "Коммерческие объекты"];
